import React from 'react';
import styled, { keyframes } from 'styled-components';

const InfiniteLooper = ({ children, direction }) => {
  return (
    <InfiniteLooperWr>
      <MarqueeBlock>
        <MarqueeInner $direction={direction}>
          {Array.from({ length: 16 }, () => '').map((_, index) => (
            <MarqueeItem key={index} $direction={direction}>
              {children}
            </MarqueeItem>
          ))}
        </MarqueeInner>
      </MarqueeBlock>
    </InfiniteLooperWr>
  );
};

const marqueeAnimation = keyframes`
  0% {
    transform: translateY(0);
 
  }
  100% {
    transform: translateY(-100%);
  
  }
`;

const InfiniteLooperWr = styled.div`
  text-align: center;
  width: 100%;
  height: 120vh;
  height: 120svh;

  overflow: hidden;
`;

const MarqueeBlock = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
`;

const MarqueeInner = styled.div`
  display: block;
  height: 100%;
  width: 100%;
  position: absolute;
  animation: ${marqueeAnimation} 30s cubic-bezier(0.05, 0, 0.94, 1) infinite;
  animation-direction: ${({ $direction }) =>
    $direction === 'down' ? 'alternate' : 'alternate-reverse'};
`;

const MarqueeItem = styled.div`
  width: fit-content;
  height: fit-content;

  & > * {
    transform: rotate(${({ $direction }) => ($direction === 'down' ? '0' : '180deg')});
  }
`;

export default InfiniteLooper;
